import {
    assertValidLocale,
    Country,
    DEFAULT_LOCALE,
    getOptions,
    getSafe,
    Locale,
    RequestOrganizationViewModel,
    VerificationResponse,
    ViewModel,
} from '@sheerid/jslib';
import { getQueryParamsFromUrl } from '../utils/routing/Url';

export const countryToLocale = (country: Country): Locale => {
    let locale: Locale;
    switch (country) {
      case "US":
        locale = "en-US";
        break;
      default:
        locale = "en-US";
    }
    return locale;
};

export const getLocaleSafely = (
    viewModel?: ViewModel | RequestOrganizationViewModel,
    verificationResponse?: VerificationResponse,
  ): Locale => {
    function getLocaleFromUrl(): Locale | undefined {
      const b = getQueryParamsFromUrl(window.location.href);
      const queryParamLocale = b.get("locale") as Locale;

      return queryParamLocale || undefined;
    }

    function getLocaleFromCountryChoice(country: Country): Locale | undefined {
      return country ? countryToLocale(country) : undefined;
    }

    const locale: Locale =
      getSafe(() => viewModel.localeChoice.value) ||
      getLocaleFromCountryChoice(getSafe(() => viewModel.countryChoice.value)) ||
      getOptions().locale ||
      getLocaleFromUrl() ||
      getSafe(() => verificationResponse.locale) ||
      DEFAULT_LOCALE;

    try {
      assertValidLocale(locale);

      return locale;
    } catch (error) {
      return DEFAULT_LOCALE;
    }
};
